// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__VLb0b","content":"ManualTimeModal_content__vm0FF"};